"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgEdit(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M4 12.708V16h3.292L17 6.292 13.708 3zm15.751-9.266a.848.848 0 000-1.2L17.759.249a.848.848 0 00-1.2 0L15 1.807 18.193 5z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Edit')(SvgEdit);
//# sourceMappingURL=Edit.js.map